export default "__VITE_ASSET__B9Nw974c__$_?url__"